import request from '../../config/axiosConfig';
import {
  GET_LIST_EVENTS, CREATE_EVENT, UPDATE_EVENT, DELETE_EVENT, IMPORT_EVENTS
} from '../../constants/apiEndPoint';

const eventService = {
  importExcel: async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    const { data } = await request({
      url: IMPORT_EVENTS,
      method: 'POST',
      data: formData,
      timeout: 60000, // import có thể lâu hơn, nới timeout mặc định
    });
    return data;
  },
  getList: async (dataBody) => {
    const { data } = await request({ url: GET_LIST_EVENTS, method: 'POST', data: dataBody });
    return data;
  },
  create: async (dataBody) => {
    const { data } = await request({ url: CREATE_EVENT, method: 'POST', data: dataBody });
    return data;
  },
  update: async (id, dataBody) => {
    const { data } = await request({ url: UPDATE_EVENT, method: 'POST', data: { id, ...dataBody } });
    return data;
  },
  delete: async (id) => {
    const { data } = await request({ url: DELETE_EVENT, method: 'POST', data: { id } });
    return data;
  },
};

export default eventService;
